import * as actions from '../../redux/actions';

import React, { useState } from 'react';

import { AndimarTitle } from '../../common/Title/AndimarTitle';
import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import KuposHelmet from '../../../common/KuposHelmet';
import KuposTabs from '../../../common/KuposTabs';
import MultiSlider3 from '../../common/MultiSlider/MultiSlider3';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import destinationBanner from '../../assets/tepual/destinations/destination-main.jpg';
import getIcons from '../../functions/getIcons/getIcons';
import getSlides from '../../functions/getSlides/getSlides';

const getAmenitiesItems = operator => [
  {
    text: 'Entretención',
    image: getIcons('FleetTv', operator),
  },
  {
    text: 'Baños',
    image: getIcons('FleetToilet', operator),
  },
  {
    text: 'Climatización',
    image: getIcons('FleetAc', operator),
  },
  // {
  //   text: 'Snacks',
  //   image: getIcons('FleetSnacks', operator),
  // },
  {
    text: 'Semi cama',
    image: getIcons('FleetBed', operator),
  },
];

const firstFloor = [
  ' Frazadas',
  'Almohadas',
  'Audífonos',
  'Pantalla touch',
  'Desayuno',
  'Cargador USB',
];
const secondFloor = [' Frazadas', 'Almohadas', 'Audífonos', 'Desayuno', 'Cargador USB'];

const interStateFleetOne = [
  ' Motor electrónico Volvo D11A con 450 CV.',
  'Computadora abordo con diagnóstico de fallas.',
  'Suspensión neumática con control electrónico.',
  'Sistema Volvo de frenos a disco EBS5: EBS (Electronic Braking System) con ABS y control de tracción.',
  'VEB – Freno Motor Volvo con 390 CV.',
  'ESP - Sistema de Control de Estabilidad.',
  ' Tercer eje direccional.',
  'Caja de cambios inteligente Volvo I-Shift.',
];

const interStateFleetTwo = [
  'Motor con 410 HP, Ciclo diesel, 4 tiempos, 6 cilindros en línea, tapas de cilindros individual y 4 válvulas por cilindro.',
  'Computadora de abordo con diagnóstico de fallas.',
  'Suspensión neumática con capacidad máxima de eje de 7.500 Kg, barra estabilizadora. Suspensión trasera: Neumática con capacidad máxima en el eje de ( 17.500 Kg).',
  'Sistema Frenos Modelo: R660 de simple reducción. Reducción: 2.92 (opcionales disponibles). Arrastre máximo: 40.000 Kg.',
  'ESP - Sistema de Control de Estabilidad.',
  ' Caja de cambios GR875. Descripción: Tipo sincronizada de 8 marchas. Doble gama. 1 marcha atrás. Sistema de cambios automatizado Scania Opticruise.',
];

const AndimarFleet = props => {
  const operator = CommonService.getLocal('op') || props.home.operator;

  const initalState = {
    selectedTab: 1,
  };

  const [state, setState] = useState(initalState);

  const tabs = ['Volvo B450 R 6X2 Euro5', 'Scania K410 6X2 Euro3'];

  const onTabChange = tab => {
    setState({ ...state, selectedTab: tab });
  };

  const interStateFleetDetails = state.selectedTab == 1 ? interStateFleetOne : interStateFleetTwo;

  const styles = {
    singleTab: {
      marginTop: 20,
      background: operator && operator.theme_color2,
      padding: 15,
      justifyContent: 'space-around',
      color: '#fff',
      borderTopRightRadius: 50,
      borderBottomRightRadius: 50,
    },
    interCityContainer: {
      background: '#F3F7FF',
      // height: 300,
      marginTop: -20,
      borderRadius: 10,
      paddingTop: 50,
      paddingLeft: 100,
      paddingRight: 100,
      paddingBottom: 30,
    },
  };

  return (
    <div>
      <KuposHelmet />
      <HeroSection
        heroImage={getIcons('FleetBanner', operator)}
        height={'41vh'}
        title={'Flota'}
        description={'Home / Flota'}
        marginTop="-70px"
      />

      <div className="new-container">
        {/* Amenities section  */}
        <AndimarTitle title={'FLOTA'} />
        <div className="light-blue-background"></div>
        <div className="take-care d-flex " style={{ justifyContent: 'space-around' }}>
          {getAmenitiesItems(operator).map(item => (
            <div
              className="take-care-item d-flex flex-column align-items-center text-center"
              style={{ width: '25%' }}
            >
              <img src={item.image} alt="" />
              <p className="mt-2 montserrat">{item.text}</p>
            </div>
          ))}
        </div>
        {/* Amenities section ends here  */}

        <div className="favorite-destinations-heading d-flex align-center  my-4">
          <div
            className="px-4 text-uppercase m-0 bold-22 montserrat-bold less-bold-text"
            style={{ color: '#2E3191' }}
          >
            {'NUESTRAS COMODIDADES'}
          </div>
          <span className="d-inline-block title-dash-line"></span>
        </div>
      </div>
      <div
        className="new-container"
        style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', marginTop: 20 }}
      >
        <div style={{ marginTop: '10px' }}>
          <img src={getIcons('AmenitiesLeftImage', operator)} alt="" />
        </div>
        <div style={{ width: '80%' }}>
          <div className="d-flex font10 montserrat-bold" style={styles.singleTab}>
            <div>Primer Piso</div>
            <div>Segundo Piso</div>
          </div>

          <div
            className="d-flex font10 montserrat"
            style={{ padding: 15, justifyContent: 'space-around' }}
          >
            <div>
              {firstFloor.map((item, key) => {
                return (
                  <div style={{ marginBottom: key != 7 ? 8 : 0 }}>
                    <span style={{ color: operator.theme_color3 }}>-</span> {item}
                  </div>
                );
              })}
            </div>
            {/* <div style={{ width: 1, background: operator.theme_color3 }}></div> */}
            <div>
              {secondFloor.map(item => {
                return (
                  <div style={{ marginBottom: 8 }}>
                    <span style={{ color: operator.theme_color3 }}>-</span> {item}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="new-container">
        <AndimarTitle title={'NUESTRA FLOTA INTERURBANA'} />
        <KuposTabs
          tabs={tabs}
          onTabChange={onTabChange}
          selectedTab={state.selectedTab}
          operator={operator}
          width={'194px'}
        />
        <div style={styles.interCityContainer}>
          {interStateFleetDetails.map(item => {
            return (
              <div className="font10 montserrat" style={{ marginBottom: 15, lineHeight: 1.3 }}>
                <span style={{ color: 'red' }}>{'- '}</span>
                {item}
              </div>
            );
          })}
        </div>

        <AndimarTitle title={'GALERÍA'} />
        <MultiSlider3
          multiSlides={getSlides('Fleet', operator)}
          removeArrowOnDeviceType={[]}
          andrimarArrowStyle
          operator={operator}
        />
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AndimarFleet);



// WEBPACK FOOTER //
// ./src/features/themes/themes1/AndimarPages/AndimarFleet.js